<template>
    <div>
        <div class="view-flex">
            <div v-if="checked.media_id" class="video-box">
                <video-player class="vjs-custom-skin"
                              :options="{
            preload: 'auto',
            aspectRatio: '16:9',
            fluid: true,
            sources: [{
              // mp4
              type: 'video/mp4',
              src: checked.url
            }],
            notSupportedMessage: '此视频暂无法播放，请稍后再试',
            controlBar: false
          }">
                </video-player>
            </div>
            <div @click="showVideos" class="upload-box">
                <i class="iconfont icon-video"></i>
            </div>
        </div>
        <el-dialog class="video_dialog" title="选择视频" :visible.sync="visible" append-to-body>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <!-- <el-tab-pane v-if="$store.getters.login_type != 'distributor'"  label="微信上传" name="wechatvideos">
                    <div>
                        <el-row :gutter="10" v-loading="loading">
                            <el-col :span="6" v-for="(item, index) in videoList" :key="index" class="media-item"
                                    :class="{'checked' : temp.media_id === item.media_id}">
                                <video-player class="vjs-custom-skin"
                                              :options="{
                                                        preload: 'auto',
                                                        aspectRatio: '16:9',
                                                        fluid: true,
                                                        sources: [{
                                                          // mp4
                                                          type: 'video/mp4',
                                                          src: item.url
                                                        }],
                                                        notSupportedMessage: '此视频暂无法播放，请稍后再试',
                                                        controlBar: false
                                                      }">
                                </video-player>
                                <div class="video-caption view-flex view-flex-middle" @click="checkVideo(item)">
                                    <div class="view-flex-item video-name">{{item.name}}</div>
                                    <div class="check-btn iconfont icon-check"></div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-pagination
                                background
                                layout="total, sizes, prev, pager, next"
                                @current-change="handleCurrentChange"
                                @size-change="handleSizeChange"
                                :current-page.sync="params.page"
                                :page-sizes="[10,20,50]"
                                :total="total_count"
                                :page-size="params.pageSize">
                        </el-pagination>
                    </div>
                </el-tab-pane> -->
                <el-tab-pane label="本地上传" name="localvideos">
                    <div>
                        <el-row :gutter="10" v-loading="localloading">
                            <el-col>
                              <div class="img_pick_area">
                                <div class="sub_title_bar in_dialog">
                                  <div class="upload_box" v-if="filesystem == 'qiniuvideo'">
                                    <el-upload
                                            class="upload-demo"
                                            :multiple="true"
                                            :action="actionPath"
                                            accept="video/mp4"
                                            :show-file-list="false"
                                            :data="postData"
                                            :before-upload="beforeVideoUpload"
                                            :on-success="handleVideoSuccess"
                                    >
                                        <el-button type="primary">本地上传</el-button>
                                        <div slot="tip" class="el-upload__tip">只能上传mp4文件，且不超过300M，若视频文件过大，请先自行压缩</div>
                                    </el-upload>
                                  </div>
                                  <div class="upload_box" v-else>
                                    <el-upload
                                            class="upload-demo"
                                            :multiple="true"
                                            :action="temporary_url"
                                            :http-request="httpRequest"
                                            accept="video/mp4"
                                            :show-file-list="false"
                                            :data="postData"
                                            :before-upload="beforeVideoUpload"
                                            :on-success="handleVideoSuccess"
                                    >
                                        <el-button type="primary">本地上传</el-button>
                                        <div slot="tip" class="el-upload__tip">只能上传mp4文件，且不超过300M，若视频文件过大，请先自行压缩</div>
                                    </el-upload>
                                  </div>
                                </div>
                              </div>
                            </el-col>
                            <el-col :span="6" v-for="(item, index) in localvideoList" :key="index" class="media-item"
                                    :class="{'checked' : temp.media_id === item.url}">
                                <video-player class="vjs-custom-skin"
                                              :options="{
                                                        preload: 'auto',
                                                        aspectRatio: '16:9',
                                                        fluid: true,
                                                        sources: [{
                                                          // mp4
                                                          type: 'video/mp4',
                                                          src: item.url
                                                        }],
                                                        notSupportedMessage: '此视频暂无法播放，请稍后再试',
                                                        controlBar: false
                                                      }">
                                </video-player>
                                <div class="video-caption view-flex view-flex-middle" @click="checkLocalVideo(item)">
                                    <div class="view-flex-item video-name">{{item.image_name}}</div>
                                    <div class="check-btn iconfont icon-check"></div>
                                </div>
                            </el-col>
                        </el-row>
                        <el-pagination
                                background
                                layout="total, sizes, prev, pager, next"
                                @current-change="handleLocalCurrentChange"
                                @size-change="handleLocalSizeChange"
                                :current-page.sync="params.page"
                                :page-sizes="[10,20,50]"
                                :total="total_count"
                                :page-size="params.pageSize">
                        </el-pagination>
                    </div>
                </el-tab-pane>
            </el-tabs>
            <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
        </el-dialog>
    </div>
</template>
<script>
  import axios from 'axios'
  import {getWechatMaterial} from '../../api/wechat'
  import {deleteVideo, getQiniuVideoList, getUploadQiniuVideoToken, uploadQiniuVideo} from '../../api/qiniu'

  export default {
    props: {
      data: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      return {
        temporary_url: '',
        filesystem: 'qiniuvideo',
        actionPath: 'https://up-z1.qiniup.com',
        postData: {
          token: '',
          key: '',
          fname: ''
        },
        checked: '',
        temp: '',
        videoList: [],
        localvideoList: [],
        loading: false,
        localloading: false,
        activeName: 'localvideos',
        params: {
          type: 'video',
          page: 1,
          pageSize: 20
        },
        localparams: {
          page: 1,
          pageSize: 20
        },
        total_count: 0,
        visible: false
      }
    },
    watch: {
      data(val) {
        val.url = val.media_id
        this.checked = val
      }
    },
    methods: {
      httpRequest (item) {
        console.log(item)
        const that = this
        const file = item.file
        axios.put(item.action, file, {
          headers: {
            'Content-Type': file.type
          }
        }).then(function (res) {
          if (res.status == 200) {
            let data = {}
            data.key = res.request.responseURL
            file.raw = {
              type: file.type
            }
            that.handleVideoSuccess(data, file)
          } else {
            that.$message({
              message: '上传失败',
              type: 'failed',
              duration: 5 * 1000
            })
          }
        })
      },
      showVideos() {
        this.visible = true
        this.temp = this.checked
        if (this.$store.getters.login_type == 'distributor') {
          this.activeName = 'localvideos'
          this.fetchLocalVideos()
        } else {
          this.fetchLocalVideos()
          // this.fetchVideos()
        }
      },
      fetchVideos() {
        this.loading = true
        getWechatMaterial(this.params).then(response => {
          this.activeName = 'wechatvideos'
          this.videoList = response.data.data.item
          this.loading = false
          this.total_count = response.data.data.total_count
        }).catch(function (error) {
          // this.loading = false
        })
      },
      fetchLocalVideos() {
        this.localloading = true
        this.activeName = 'localvideos'
        this.localparams.storage = this.filesystem
        getQiniuVideoList(this.localparams).then(response => {
          this.localvideoList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.localloading = false
        }).catch(function (error) {
          // this.localloading = false
        })
      },
      handleCurrentChange(page_num) {
        this.params.page = page_num
        this.fetchLocalVideos()
      },
      handleSizeChange(pageSize) {
        this.params.page = 1
        this.params.pageSize = pageSize
        this.fetchLocalVideos()
      },
      handleLocalCurrentChange(page_num) {
        this.localparams.page = page_num
        this.fetchLocalVideos()
      },
      handleLocalSizeChange(pageSize) {
        this.localparams.page = 1
        this.localparams.pageSize = pageSize
        this.fetchLocalVideos()
      },
      checkVideo(item) {
        this.temp = item
      },
      checkLocalVideo(item) {
        this.temp = {
          desc: item.brief,
          media_id: item.url,
          name: item.image_name,
          update_time: item.updated,
          url: item.url
        }
      },
      handleCancel() {
        this.visible = false
        this.temp = ''
      },
      handleSubmit() {
        if (this.checked) {
          this.visible = false
          this.checked = this.temp
          this.$emit('change', this.checked)
        } else {
          this.$message('请选择视频')
        }
      },
      handleClick(tab, event) {
        if(this.activeName=="wechatvideos"){
          this.fetchVideos()
        }else{
          this.fetchLocalVideos()
        }
      },
      beforeVideoUpload(file) {
        const isMP4 = file.type === 'video/mp4';
        const isLt2M = file.size / 1024 / 1024 < 500;
        if (!isMP4) {
          this.$message.error('上传视频只能是 mp4 格式!')
          return
        }
        if (!isLt2M) {
          this.$message.error('上传视频大小不能超过 300MB!')
          return
        }
        this.postData.fname = file.name
        let tokenParams = {filename: file.name, filesystem: this.filesystem}
        if (this.filesystem == 'qiniuvideo') {
          return getUploadQiniuVideoToken(tokenParams).then(response => {
            this.postData.token = response.data.data.token
            this.postData.key = response.data.data.key
            this.image_prefix = response.data.data.domain
          })
        } else {
          return getUploadQiniuVideoToken(tokenParams).then(response => {
            this.temporary_url = response.data.data.temporary_url
            this.image_prefix = response.data.data.domain
          })
        }
      },
      handleVideoSuccess(res, file) {
        let uploadParams = {
          image_cat_id: 2,    //视频分类必填,必须为整数
          image_name: file.name,   //视频名称必填,不能超过50个字符
          brief: file.name,   //视频名称必填,不能超过50个字符
          image_url: res.key,    //视频链接必填
          // image_name: this.videoForm.title,   //视频名称必填,不能超过50个字符
          // brief: this.videoForm.description,   //视频名称必填,不能超过50个字符
          // image_full_url: res.height,   //视频完整链接必填
          image_type: file.raw.type,   //视频分类长度不能超过20个字符
          storage: this.filesystem,   //视频id必填
        }
        uploadQiniuVideo(uploadParams).then(res => {
          this.$message({
            message: '上传成功',
            type: 'success',
            duration: 5 * 1000
          })
          this.fetchLocalVideos()
        })
      },
    },
    created() {
      this.checked = this.data
    }
  }
</script>

<style scoped lang="scss">
    .media-item {
        .video-caption {
            padding-top: 5px;
            cursor: pointer;

            .video-name {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .check-btn {
                width: 19px;
                height: 19px;
                margin-left: 5px;
                text-align: center;
                line-height: 19px;
                border-radius: 50%;
                color: #ccc;
                background: #efefef;
                font-size: 0.1em;
                border: 1px solid #ccc;
            }
        }

        &.checked {
            .video-caption {
                .video-name {
                    color: #46a0fc;
                    font-weight: bold;
                }

                .check-btn {
                    color: #fff;
                    background: #46a0fc;
                    border: 1px solid #46a0fc;
                }
            }
        }
    }

    .img_pick_area {
      position: relative;
      overflow-x: hidden;
      overflow-y: hidden;
    }
    .sub_title_bar {
      line-height: 36px;
      margin-bottom: 10px;
      text-align: left;
      border-bottom: 1px solid #e7e7eb;
      background-color: #fff;
      &.in_dialog {
        padding: 0 0 15px;
      }
    }
    .upload-box {
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        overflow: hidden;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;

        .iconfont {
            font-size: 30px;
            color: #ccc;
        }
    }

    .video-box {
        margin-right: 10px;
        width: 213px;
        height: 120px;
        border: 1px dashed #c0ccda;

        video {
            width: 100%;
            height: 100%;
        }
    }
</style>



// WEBPACK FOOTER //
// index.vue?a3cd1f00